export enum ReportingPeriodStatuses {
  Active = 'Active',
  Inactive = 'Inactive'
}
